/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
$(function() {
  $('body').on('change', '[data-submit]', function() {
    if ($(this).is(':checked')) {
      $(this).parents('form').submit();
      var product_id = $(this).data("product-id");

      var suggested_product = $("#comparable_item_product_" + $(this).data("product-id") + '.suggested-comparable-item');
      // Animate out the suggested comparable product
      return suggested_product.animate({left: '600'}, 400).slideUp(300, function() {
        // Remove the suggested element from the dom
        suggested_product.find(".remove-link").remove();
        var form = suggested_product.find("form");
        form.replaceWith('<a class="icon icon-close vertical-align-element" data-remove-selection="true" data-method="delete" data-remote="true" href="' + form.attr('action') + '" rel="nofollow"></a>');

        // If there's no more suggestions, add a bit of helper text.
        if ($.trim($('.suggested-comparable-items').html()) === '') {
          $('.suggested-comparable-items').prepend($('<li id="suggested-helper-text">Sorry, there are no more suggested products available.</li>'));
        }

        // Render the selected comparable item partial as a hidden element
        // Set it to the right with a height of nothing
        // Animate out the height then slide it in from the right hand side, smooth sailing
        $('.selected-comparable-items').prepend(suggested_product);
        suggested_product.addClass('in');
        suggested_product.css('left', '600px').removeClass('in').slideUp(0);
        suggested_product.slideDown(300, function() {
          return suggested_product.animate({left: '0'}, 400);
        });

        // Enable the compare button since if we have more than one comparable item
        if ($('ul.selected-comparable-items li').length > 1) {
          $('.selected-comparisons .button')
            .removeClass('disabled')
            .removeClass('button--red')
            .addClass('button--green');

          $('.js-product-module-compare .button').addClass('button--green');
        }

        // Reset the suggestion list to show the top ten
        return $('.suggested-comparable-item').each(function(index) {
          $(this).removeClass();
          $(this).addClass('flex items-center justify-between mb3 suggested-comparable-item');
          return $(this).addClass("suggested-comparable-item-" + index);});
      });
    }
  });

  $('body').on('click', '[data-remove-selection]', function(e) {
    $(this).parents("li").remove();

    // If there is not enough items to compare
    if ($('ul.selected-comparable-items li').length <= 1) {
      // Disable the compare button
      $('.selected-comparisons .button')
        .removeClass('button--green')
        .addClass('button--red')
        .addClass('disabled');

      return $('.js-product-module-compare .button').removeClass('button--green');
    }
  });


  $('body').on('click', '[data-remove-suggestion]', function(e) {
    e.preventDefault;

    $("#".concat($(this).data('remove-suggestion'))).slideUp('slow').remove();

    if ($.trim($('.selected-comparable-items').html()) === '') {
      $('.selected-comparisons .button').addClass('disabled');
    }

    $('.suggested-comparable-item').each(function(index) {
      $(this).removeClass();
      $(this).addClass('suggested-comparable-item');
      return $(this).addClass("suggested-comparable-item-" + index);
    });

    if ($.trim($('.suggested-comparable-items').html()) === '') {
      return $('.suggested-comparable-items').prepend($('<li id="suggested-helper-text">Sorry, there are no more suggested products available.</li>'));
    }
  });

  return $('body').on('change', '.js-product-module-compare, .product-compare', function() {
    var input  = $(this).find('[type="checkbox"]');
    var button = $(this).next('.js-product--button-compare');
    var text   = $(this).find('.js-label-inner');
    var product_module = $(this).closest('.js-product-panel');
    button.toggleClass('js-dn', !input.is(':checked'));
    text.toggleClass('js-dn', input.is(':checked'));

    if (input.is(':checked')) {
      product_module.addClass('js-product-panel--comparing');
      return $.post(input.data('action'), {'update_list': true });
    } else {
      product_module.removeClass('js-product-panel--comparing');
      return $.post(input.data('action'), {'_method':'delete', 'update_list': true });
    }
});});
